/**
 * GovEarner / multi-tenant workspace auto-select helpers.
 */

const GOVEARNER_HOSTS = new Set(['govearner.com', 'www.govearner.com']);

/** True when the SPA is served from GovEarner production (or local dev with that host). */
export function isGovEarnerHost(hostname?: string): boolean {
  const host = (hostname ?? (typeof window !== 'undefined' ? window.location.hostname : '')).toLowerCase();
  return GOVEARNER_HOSTS.has(host);
}

/**
 * Skip the manual workspace picker when tenant/project defaults are baked into config
 * (VITE_TENANT_ID / VITE_PROJECT_ID) or the user only has one tenant to choose.
 */
export function shouldSkipWorkspacePicker(options: {
  defaultTenantId?: string;
  defaultProjectId?: string;
  tenantCount?: number;
  hostname?: string;
}): boolean {
  const { defaultTenantId, defaultProjectId, tenantCount = 0, hostname } = options;

  if (defaultTenantId && defaultProjectId) {
    return true;
  }

  if (isGovEarnerHost(hostname) && defaultTenantId) {
    return true;
  }

  if (tenantCount === 1 && defaultTenantId) {
    return true;
  }

  return false;
}

/** Auto-enter the app when only one project is available for the active tenant. */
export function shouldAutoEnterSingleProject(projectCount: number): boolean {
  return projectCount === 1;
}
